import styled from 'styled-components/native';
import { ScrollView, ScrollViewProps } from 'react-native';
import React from 'react';

function BaseAppScrollView(props: ScrollViewProps) {
  return <Component keyboardShouldPersistTaps="handled" showsVerticalScrollIndicator={false} {...props} />;
}

const Component = styled(ScrollView).attrs({
  contentContainerStyle: { flexGrow: 1 },
})`
  flex: 1;
`;

export const AppScrollView = React.memo(BaseAppScrollView);
